import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  manageProjectInvitation,
  ManageProjectInvitationInput,
} from '@/features/projects/project-invitation/api/manage-project-invitation';

type Props = Omit<
  UseMutationOptions<
    Awaited<ReturnType<typeof manageProjectInvitation>>,
    unknown,
    ManageProjectInvitationInput
  >,
  'mutationFn'
>;

export const useManageProjectInvitationMutation = ({ ...props }: Props) => {
  return useMutation({
    ...props,
    mutationFn: async (data) => {
      const { invitationToken, status } = data;
      return await manageProjectInvitation({ invitationToken, status });
    },
  });
};
